import { Utils } from '@pacem/pacem-core';
const DefaultDirectionalLightReferences = {
    normal: 'normal', inputColor: 'white'
};
export function directionalLight(references, group, binding) {
    const key = Utils.uniqueCode();
    const lightReference = `directional_${key}`;
    const ref = Utils.extend({}, DefaultDirectionalLightReferences, references);
    const inputColor = ref.inputColor, outputColor = ref.outputColor, normal = ref.normal ?? 'normal';
    if (Utils.isNullOrEmpty(inputColor)) {
        throw new Error('Must provide input vertex color parameter name.');
    }
    return {
        // type definitions
        definitions: [`struct DirectionalLight {
    color: vec4f,
    direction: vec3f,
    intensity: f32
}`, `fn computeDirectional(normal: vec3f, color: vec4f, light: DirectionalLight) -> vec4f {
    let n = normalize(normal);
    let d = normalize(light.direction);
    let factor = light.intensity * .5 * (1.0 + dot(n, -d));
    let output = color.rgb * light.color.rgb * factor;
    return vec4f(output, color.a);
}`],
        // bindings
        bindings: [`@group(${group}) @binding(${binding}) var<uniform> ${lightReference}: DirectionalLight;`],
        // modifiers
        modifiers: outputColor ? [`${outputColor} += computeDirectional(${normal}, ${inputColor}, ${lightReference});`] : [`computeDirectional(${normal}, ${inputColor}, ${lightReference})`]
    };
}
